import { DraftsRounded } from '@material-ui/icons';
import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function frentista(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@frentista/FIND_FRENTISTA':
      case '@frentista/UPDATE_FRENTISTA':
      case '@frentista/DELETE_FRENTISTA':
      case '@frentista/STORE_FRENTISTA':
      case '@frentista/FRENTISTAS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@frentista/SUCCESS_REMOVE':
      case '@frentista/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@frentista/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.frentistas;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@frentista/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.frentista;
        break;
      }

      case '@frentista/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = { poco_codigo: draft.params.poco_codigo, ...action.payload.params }
        break;
      }

      case '@frentista/CHANGE_POSTO': {
        draft.params = { poco_codigo: action.payload.params.poco_codigo }
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        break;
      }


      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
